import { Close, Launch } from '@mui/icons-material';
import { IconButton, Skeleton } from '@mui/material';
import { ChevronLeft } from 'lucide-react';
import React from 'react';

import * as Utility from '../../../core/utility';
import InstagramIcon from '../../../components/icons/instagram-icon';
import YouTubeIcon from '@mui/icons-material/YouTube';
import { InfluencerCampaignCard } from '../../../components';
import { DummyCampaignImage } from '../../../config/config';
import DeliverableInfo from '../../../components/deliverables/deliverables';
import IconGender from '../../../components/icons/icon-gender';
import IconCategory from '../../../components/icons/icon-category';
import IconLocation from '../../../components/icons/icon-location';
import { Link } from 'react-router-dom';
import dayjs from 'dayjs';

type Props = {
    handleCampaignDetailPopupClose:any;
    campaign_id:number;
    campaignDetailDrawerContent:any;
   
    loading:Boolean;
    handleClickShare:any;
    handleCampaignApply:any;
    btnName:string;
    userReducer:any;
    checkInfType:any;
    handleCampaign:any
}

const methods: Utility.Methods = new Utility.Methods();

const CampaignDetailDesktopDrawer = ({handleCampaign, checkInfType, userReducer, btnName, handleClickShare, handleCampaignApply, loading, campaignDetailDrawerContent, campaign_id, handleCampaignDetailPopupClose}: Props) => {
  return (
 
    <>
      {/* POPUP DRAWER HEADER */}
            <div className='popup-drawer-header'>
              <div className='popup-drawer-header-left'>
               
                <IconButton
                  onClick={() =>
                    handleCampaignDetailPopupClose(campaign_id)
                  }
                >
                  <ChevronLeft className='d-none d-md-inline-flex' />
                  <Close className='d-inline-flex d-md-none' />
                </IconButton>
              </div>
              <div className='popup-drawer-header-right'>
                <div className={campaignDetailDrawerContent?.data?.rows.days_old > 0 ? "d-flex flex-column" : ""}>
                  <div className='d-flex'>
                    <button
                      className='btn btn-outline-primary btn-mui btn-rounded btn-lg'
                      onClick={(event) =>
                        handleClickShare(event, campaignDetailDrawerContent)
                      }
                    >
                      Share
                    </button>

                    {(campaignDetailDrawerContent && campaignDetailDrawerContent?.data?.rows.days_old < 1 &&
                      (campaignDetailDrawerContent?.data?.rows.influencer_gender === "Any" ||
                        campaignDetailDrawerContent?.data?.rows.influencer_gender === userReducer.gender)
                    ) ? (
                      <button onClick={handleCampaignApply} className="btn btn-primary btn-mui btn-rounded btn-lg ms-2">
                        {btnName}
                      </button>
                    ) : (
                      (btnName == 'Apply now') ?
                        <button className="btn btn-primary btn-mui btn-rounded btn-lg disabled ms-2">
                          {btnName}
                        </button> :
                        <button onClick={handleCampaignApply} className="btn btn-primary btn-mui btn-rounded btn-lg ms-2">
                          {btnName}
                        </button>
                    )}
                  </div>
                  {campaignDetailDrawerContent && campaignDetailDrawerContent?.data?.rows.days_old >= 1 && btnName === 'Apply now' &&
                    <span className=' text-sm-start text-md-end' style={{ color: '#E50000', marginTop: '10px' }} >
                      Application Closed
                    </span>
                  }
                  {/* {campaignDetailDrawerContent &&
                    userReducer != null &&
                    campaignDetailDrawerContent?.data?.rows?.influencer_gender !== 'Any' &&
                    (campaignDetailDrawerContent?.data?.rows?.influencer_gender !== userReducer?.influencer_ids?.[0]?.gender ||
                      !userReducer?.influencer_ids?.[0]) &&
                    btnName === 'Apply now' && (
                      <span className='error'>
                        {campaignDetailDrawerContent?.data?.rows?.influencer_gender !== 'Any' ||campaignDetailDrawerContent?.data?.rows?.influencer_gender !== userReducer?.influencer_ids?.[0]?.gender ? `This campaign is open to ${campaignDetailDrawerContent?.data?.rows?.influencer_gender} influencers only.` : "You are not eligible to apply on this campaign."}
                        
                      </span>
                    )} */}

                  {campaignDetailDrawerContent &&
                    userReducer &&
                    btnName === 'Apply now' && (
                      (() => {
                        const influencerGenderRequirement = campaignDetailDrawerContent?.data?.rows?.influencer_gender;
                        // Case when influencerGenderRequirement is null or undefined
                        if (influencerGenderRequirement == null) {
                          return
                        }
                        const userInfluencerGender = userReducer?.gender;
                        
                        // If the influencer gender is not 'Any' and the user's gender doesn't match
                        if (
                          influencerGenderRequirement !== 'Any' &&
                          (!userInfluencerGender || influencerGenderRequirement !== userInfluencerGender)
                        ) {
                          return (
                            <span className="error">
                              {influencerGenderRequirement !== 'Any'
                                ? `This campaign is open to ${(influencerGenderRequirement).toLowerCase()} influencers only.`
                                : 'You are not eligible to apply on this campaign.'}
                            </span>
                          );
                        }

                        return null; // If the user meets the gender requirement
                      })()
                    )}


                  {checkInfType.status && btnName === 'Apply now' && <span className='error'>You are not eligible to apply on this campaign.</span>}
                </div>
              </div>
            </div>
            {/* END POPUP DRAWER HEADER */}
            {/* POPUP DRAWER BODY */}
            <div className='popup-drawer-body'>
              <div className='dashboard-card'>
                <div className='dashboard-card-right'>
                  <div className='dashboard-card-right-top'>
                    <div className='dashboard-card-right-top-left'>
                      {(campaignDetailDrawerContent?.data?.rows.reveal_brand_name === 'true') &&
                        <p>{campaignDetailDrawerContent?.data?.rows.brand_name}</p>
                      }
                      <h3 className='dashboard-card-title'>
                        {loading ? <Skeleton animation="wave" /> : campaignDetailDrawerContent?.data?.rows.campaign_title}
                        <span
                          className='ms-2 dashboard-card-title-redirect-link'
                          style={{ verticalAlign: 'text-top' }}
                          onClick={handleCampaign}
                        >
                          <Launch/>
                        </span>
                      </h3>
                      <span className='d-block color-blk-5d fs-14 mb-1'>
                        Posted{' '}
                        {loading ? <Skeleton animation="wave" /> : methods.calculateDaysDifference(
                          new Date(
                            campaignDetailDrawerContent?.data?.rows?.posted_at
                          ),
                          new Date()
                        )}{' '}
                        days ago
                      </span>
                    </div>

                    <div className='dashboard-card-right-top-right'>
                      {loading ? <Skeleton animation="wave" /> :
                        <span className='badge badge-primary-outline'>
                          {(
                            campaignDetailDrawerContent?.data?.rows
                              ?.campaign_platform + ''
                          ).toLocaleLowerCase() === 'instagram' ? (
                            <InstagramIcon width="20px" height="20px" />
                          ) : (
                            <YouTubeIcon width="20px" height="20px" />
                          )}

                          {campaignDetailDrawerContent?.data?.rows?.campaign_type
                          }
                        </span>
                      }
                    </div>

                  </div>
                  <strong>Description</strong>
                  <InfluencerCampaignCard
                    description=
                    {loading ? <Skeleton animation="wave" /> : campaignDetailDrawerContent?.data?.rows?.campaign_description
                    }
                     about_brand=
                    {loading ? <Skeleton animation="wave" /> : campaignDetailDrawerContent?.data?.rows?.about_brand
                    }
                    updated_at={loading ? <Skeleton animation="wave" /> :
                      campaignDetailDrawerContent?.data?.rows?.updated_at
                    }
                  />
                  {/* BRAND_WEB_URL */}
                    {campaignDetailDrawerContent?.data?.rows.reveal_brand_name === 'true' && (
                      <a
                        href={
                          campaignDetailDrawerContent?.data?.rows?.brand_web_url?.startsWith('http')
                            ? campaignDetailDrawerContent?.data?.rows.brand_web_url
                            : `https://${campaignDetailDrawerContent?.data?.rows.brand_web_url}`
                        }
                        target='_blank'
                        rel='noopener noreferrer'
                        className='text-decoration-none d-block mt-2 word-break'
                        style={{ fontSize: '14px', fontWeight: 400 }}
                      >
                        {campaignDetailDrawerContent?.data?.rows?.brand_web_url}
                      </a>
                    )}
                </div>
              </div>
              {/* PRODUCT DETAIL SECTION */}
              {campaignDetailDrawerContent?.data?.rows?.campaign_type === "Paid + Barter" || campaignDetailDrawerContent?.data?.rows?.campaign_type === "Barter" ?
                <div className='camp-detail-card grid-2-row'>
                  <strong className='camp-detail-card-sec-title'>
                    Product Details
                  </strong>
                  <div className='camp-detail-card-inner'>
                    <div className='camp-detail-card-left'>
                      <div className='product-detail-info'>
                        <div className='product-detail-img'>
                          <img
                            className='product-image'
                            src={loading ? <Skeleton animation="wave" /> :
                              campaignDetailDrawerContent?.data?.rows
                                ?.product_image_url ? campaignDetailDrawerContent?.data?.rows
                                ?.product_image_url : DummyCampaignImage.default_campaign_image
                            }
                            alt='product cover'
                          />
                        </div>
                        <div className='product-detail-price-info'>
                          <span>
                            {loading ? <Skeleton animation="wave" /> :
                              campaignDetailDrawerContent?.data?.rows
                                ?.product_name
                            }
                          </span>
                          <span>
                            Worth{' '}
                            <strong>
                              {loading ? <Skeleton animation="wave" /> :
                                campaignDetailDrawerContent?.data?.rows
                                  ?.product_cost
                              }
                            </strong>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className='camp-detail-card-right'>
                      <div className='row'>
                        <InfluencerCampaignCard
                          description=
                          {loading ? <Skeleton animation="wave" /> : campaignDetailDrawerContent?.data?.rows?.product_description
                          }
                          updated_at={loading ? <Skeleton animation="wave" /> :
                            campaignDetailDrawerContent?.data?.rows?.updated_at
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
                : null}

              {/* END - PRODUCT DETAIL SECTION */}
              {/* DELIVERABLE SECTION */}
              <div className='camp-detail-card grid-1-col'>
                <strong className=' camp-detail-card-sec-title'>
                  Deliverables
                </strong>
                <div className='camp-detail-card-inner grid-3-col '>
                  <DeliverableInfo deliverablesData={campaignDetailDrawerContent?.data?.rows} loading={loading} />
                  {/* {campaignDetailDrawerContent?.data?.rows?.deliverables.map((mainDeliverable: any) => {
                    return <div className={campaignDetailDrawerContent?.data?.rows.influencer_type &&
                      mainDeliverable.influencer_type.includes(
                        campaignDetailDrawerContent?.data?.rows?.influencer_type
                      )
                      ? "deliverable-list active-deliverable "
                      : "deliverable-list"}>
                      <strong> {loading ? <Skeleton animation="wave" /> : mainDeliverable?.influencer_type}</strong>
                      <ul>
                        {mainDeliverable?.deliverables?.map((deliverable: any, index: number) => {
                          return <li key={index}>{loading ? <Skeleton animation="wave" /> : deliverable.split(",")}</li>
                        })}
                      </ul>
                    </div>
                  })} */}
                </div>
              </div>
              {/* DELIVERABLE SECTION ENDS */}
              {/* INFLUENCER DETAIL SECTION */}
              <div className='camp-detail-card grid-2-row'>
                <strong className='camp-detail-card-sec-title'>
                  Influencer Details
                </strong>
                <div className='infl-det-list-sec'>
                  <div className='infl-det-list'>
                    <div className='infl-det-list-icon'>
                      <IconGender />
                    </div>
                    <div className='infl-det-list-content'>
                      <strong>Gender </strong>

                      <ul>
                        <li> {loading ? <Skeleton animation="wave" /> : campaignDetailDrawerContent?.data?.rows?.influencer_gender}</li>
                      </ul>
                    </div>
                  </div>
                  {campaignDetailDrawerContent?.data?.rows?.categories &&
                    <div className='infl-det-list'>
                      <div className='infl-det-list-icon'>
                        <IconCategory />
                      </div>
                      <div className='infl-det-list-content'>
                        <strong>Category </strong>
                        <ul>
                          {
                            campaignDetailDrawerContent?.data?.rows?.categories &&
                              campaignDetailDrawerContent?.data?.rows?.categories.trim() !== "" ? campaignDetailDrawerContent?.data?.rows?.categories.split(",").map((cate: string) => { return <li> {loading ? <Skeleton animation="wave" /> : cate}</li> })
                              : null
                          }

                        </ul>
                      </div>
                    </div>
                  }
                  <div className='infl-det-list'>
                    <div className='infl-det-list-icon'>
                      <IconLocation />
                    </div>
                    <div className='infl-det-list-content'>
                      <strong>Location </strong>
                      <ul>
                        {campaignDetailDrawerContent?.data?.rows?.group_locations &&
                          campaignDetailDrawerContent?.data?.rows?.group_locations.trim() !== ""
                          ? methods.formatGroupLocations(campaignDetailDrawerContent?.data?.rows?.group_locations).map((location: string, idx: number) => (
                            <li key={idx}> {loading ? <Skeleton animation="wave" /> : location}</li>
                          ))
                          : <li>All Locations</li>}

                        {/* 
                        <li>Delhi, Delhi, India</li>
                        <li>Mumbai, Maharashtra, India</li> */}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              {/* END - INFLUENCER DETAIL SECTION */}
              {/* REFERENCE LINKS */}
              {campaignDetailDrawerContent?.data?.rows?.reference_link_1 || campaignDetailDrawerContent?.data?.rows?.reference_link_2 || campaignDetailDrawerContent?.data?.rows?.reference_link_3 ?
                <div className='camp-detail-card grid-2-row'>
                  <strong className='camp-detail-card-sec-title'>
                    Reference Links
                  </strong>
                  <div className='camp-detail-card-left'>
                    <div>
                      {campaignDetailDrawerContent?.data?.rows?.reference_link_1 && <p className='reference-link'> <Link target='_blank' to={
                        campaignDetailDrawerContent?.data?.rows?.reference_link_1}>
                        {campaignDetailDrawerContent?.data?.rows?.reference_link_1}</Link></p>}
                      {campaignDetailDrawerContent?.data?.rows?.reference_link_2 && <p className='reference-link'> <Link target='_blank' to={
                        campaignDetailDrawerContent?.data?.rows?.reference_link_2}>
                        {campaignDetailDrawerContent?.data?.rows?.reference_link_2}</Link></p>}
                      {campaignDetailDrawerContent?.data?.rows?.reference_link_3 && <p className='reference-link'> <Link target='_blank' to={
                        campaignDetailDrawerContent?.data?.rows?.reference_link_3}>
                        {campaignDetailDrawerContent?.data?.rows?.reference_link_3}</Link></p>}
                    </div>
                  </div>
                </div>
                : null
              }
              {/* END - REFERENCE LINKS */}
              {/* COMMENTS SECTION */}
              {campaignDetailDrawerContent?.data?.rows?.comments && (
                <div className='camp-detail-card grid-1-col'>
                  <strong className=' camp-detail-card-sec-title'>
                    Comments
                  </strong>
                  <p className='commemt'>{loading ? <Skeleton animation="wave" /> : campaignDetailDrawerContent?.data?.rows?.comments}</p>
                </div>
              )}
              {/* COMMENTS SECTION ENDS */}
              {/* CAMPAIGN LIVE DATE */}
              <div className='camp-detail-card grid-2-row'>
                <div className='infl-det-list-sec proposal-dur-info'>
                  {campaignDetailDrawerContent?.data?.rows?.proposal_dt &&
                    <div className='infl-det-list'>
                      <div className='infl-det-list-icon'>
                        <span className='material-symbols-rounded'>
                          alarm
                        </span>
                      </div>
                      <div className='infl-det-list-content'>
                        <strong>{loading ? <Skeleton animation="wave" /> : dayjs(campaignDetailDrawerContent?.data?.rows?.proposal_dt).format('LL')} </strong>
                        <ul>
                          <li>Proposal Deadline</li>
                        </ul>
                      </div>
                    </div>
                  }
                  {campaignDetailDrawerContent?.data?.rows?.go_live_dt &&
                    <div className='infl-det-list'>
                      <div className='infl-det-list-icon'>
                        <span className='material-symbols-rounded'>
                          calendar_month
                        </span>
                      </div>
                      <div className='infl-det-list-content'>
                        <strong>{loading ? <Skeleton animation="wave" /> : dayjs(campaignDetailDrawerContent?.data?.rows?.go_live_dt).format('LL')}</strong>


                        <ul>
                          <li>Campaign Live Date</li>
                        </ul>
                      </div>
                    </div>
                  }


                </div>
              </div>
              {/* END CAMPAIGN LIVE DATE*/}


            </div>
    </>
  )
}

export default CampaignDetailDesktopDrawer